import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { TechnologiesComponent } from '../../shared/technologies/technologies.component';
import { SpinnerService } from '../../services/sppiner/spinner.service';
import { SectionBannerComponent } from '../../shared/section-banner/section-banner.component';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'app-about',
  standalone: true,
  imports: [TechnologiesComponent, SectionBannerComponent, TranslateModule],
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit, AfterViewInit {
  experienceYears: number = 0;
  satisfiedClients: number = 0;
  completedProjects: number = 0;
  coffeeCups: number = 0;
  backgroundUrl: string = '';

  @ViewChild('statsSection') statsSection!: ElementRef;

  constructor(private spinnerService: SpinnerService) {}

  ngOnInit(): void {
    this.spinnerService.spinnerObservable.subscribe(show => {
      if (!show) {
        this.setupIntersectionObserver();
      }
    });
  }

  ngAfterViewInit(): void {
    this.setupIntersectionObserver();
  }

  setupIntersectionObserver(): void {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.startCounting();
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    observer.observe(this.statsSection.nativeElement);
  }

  startCounting(): void {
    this.animateValue('experienceYears', 0, 5, 2000);
    this.animateValue('satisfiedClients', 0, 300, 2000);
    this.animateValue('completedProjects', 0, 25, 2000);
    this.animateValue('coffeeCups', 0, 200, 2000);
  }

  animateValue(property: string, start: number, end: number, duration: number) {
    const range = end - start;
    const increment = end > start ? 1 : -1;
    const stepTime = Math.abs(Math.floor(duration / range));
    let current = start;
    
    const timer = setInterval(() => {
      current += increment;
      (this as any)[property] = current;
      if (current == end) {
        clearInterval(timer);
      }
    }, stepTime);
  }
}